<div
  class="flex bg-[#D4282E] rounded w-4 h-4 items-center justify-center"
  aria-hidden="true"
>
    <span class="!text-white !text-[10px]">{{messagesCounter}}</span>
</div>